
import { Database } from "@/integrations/supabase/types";

type TimeOfDay = Database["public"]["Enums"]["time_of_day"];

export interface ValidationErrors {
  title?: string;
  dates?: string;
  timeOfDay?: string;
  location?: string;
}

export const useValidateEventForm = (
  title: string,
  preferredDates: Date[],
  preferredTimeOfDay: TimeOfDay[],
  locationType: 'specific' | 'flexible',
  preferredVenues: string[],
  locationNote: string,
) => {
  const validateForm = () => {
    const errors: ValidationErrors = {};

    if (!title.trim()) {
      errors.title = "Title is required";
    }

    if (preferredDates.length === 0) {
      errors.dates = "At least one date must be selected";
    }

    if (preferredTimeOfDay.length === 0) {
      errors.timeOfDay = "At least one time of day must be selected";
    }

    if (locationType === 'specific' && preferredVenues.length === 0) {
      errors.location = "At least one venue must be selected";
    } else if (locationType === 'flexible' && !locationNote.trim()) {
      errors.location = "Location description is required";
    }

    return { errors, isValid: Object.keys(errors).length === 0 };
  };

  const isSubmitDisabled = 
    !title.trim() || 
    preferredDates.length === 0 || 
    preferredTimeOfDay.length === 0 || 
    (locationType === 'specific' ? preferredVenues.length === 0 : !locationNote.trim());

  return {
    validateForm,
    isSubmitDisabled,
  };
};
